import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=489a5480&"
import script from "./Review.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Review.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Review.vue?vue&type=style&index=0&id=489a5480&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports